import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { applyKeyframe, mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import { css, keyframes } from 'styled-components';

const { fonts } = theme;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const productsViewedWrapper = css`
  color: #021828;
  font-family: ${fonts.PRIMARY_REGULAR.family}, sans-serif;
  font-size: 0.75rem;
  grid-column: 1 / -1;
  margin: 0;
  position: relative;
  text-align: center;
  z-index: 0;

  &[data-is-divider='true'] {
    animation: ${applyKeyframe(fadeInAnimation)} 1s linear;
    margin: 0 0 ${pxToRem(8)};

    ${mediaQuery(
      { min: minBreakpoints.L },
      css`
        margin-bottom: ${pxToRem(40)};
      `,
    )};

    &::before {
      background: #aebcc6;
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      top: 50%;
      width: 100%;
      z-index: -1;
    }
  }

  &[data-is-divider='false'] {
    ${mediaQuery(
      { max: maxBreakpoints.M },
      css`
        margin-top: ${pxToRem(32)};
      `,
    )};
  }
`;

export const productsViewedText = css`
  background: #fff;
  display: inline-block;
  padding: 0 1.375rem;
`;
